import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["status"];

  submit() {
    this.element.classList.add("opacity-30", "pointer-events-none");
    if (this.hasStatusTarget) {
      this.statusTarget.innerHTML =
        '<span class="text-red-400 animate-pulse">[ REVOCANDO... ]</span>';
    }
  }
}
